module.exports = __webpack_public_path__ + "img/Cassiopeia.5b79f82e.png";